import { EventType } from 'matrix-js-sdk/lib/@types/event.js';
const CALL_MEMBER_EVENT_TYPE = EventType.RTCMembership;
const LEGACY_CALL_MEMBER_EVENT_TYPE = EventType.GroupCallMemberPrefix;
export const canJoinCall = (capabilities, hasParticipant) => capabilities.canStart ||
    (hasParticipant &&
        capabilities.webRTCSupported &&
        capabilities.hasCallMemberPermission &&
        !capabilities.inAnotherCall);
export const evaluateCallStartCapabilities = ({ room, myUserId, activeCallRoomId, livekitSupported, rtcSupported, }) => {
    const blockers = [];
    const hasCallMemberPermission = room.currentState?.maySendStateEvent(CALL_MEMBER_EVENT_TYPE, myUserId) ||
        room.currentState?.maySendStateEvent(LEGACY_CALL_MEMBER_EVENT_TYPE, myUserId) ||
        false;
    const inAnotherCall = !!activeCallRoomId && activeCallRoomId !== room.roomId;
    if (!rtcSupported)
        blockers.push('missing_webrtc');
    if (!livekitSupported)
        blockers.push('missing_livekit');
    if (!hasCallMemberPermission)
        blockers.push('missing_call_member_permission');
    if (inAnotherCall)
        blockers.push('already_in_another_call');
    const canRenderCallButton = !blockers.some((blocker) => ['missing_webrtc', 'missing_livekit', 'missing_call_member_permission'].includes(blocker));
    return {
        canStart: blockers.length === 0,
        canRenderCallButton,
        blockers,
        webRTCSupported: rtcSupported,
        livekitSupported,
        hasCallMemberPermission,
        inAnotherCall,
    };
};
//# sourceMappingURL=callStartCapabilities.js.map